// auth.utils.ts
import type { Tenant, TenantRAW, AreasComarcales } from '@/types/types';

export function normalizeTenantId(t: Tenant | null | undefined): number | null {
  return t ? t.id : null;
}

export function getTenantEntityFromRaw(raw: TenantRAW | null | undefined): Tenant | null {
  if (!raw) return null;
  return raw.tenants_id as Tenant;
}

export function normalizeAreasComarcales(
  value: Tenant['areas_comarcales'] | undefined
): AreasComarcales[] {
  if (!Array.isArray(value)) return [];
  return value.filter((x): x is AreasComarcales => typeof x === 'object' && x !== null);
}

export function normalizeMunicipios(value: Tenant['municipios'] | undefined): any[] {
  if (!Array.isArray(value)) return [];
  return value.filter((x): x is any => typeof x === 'object' && x !== null);
}

export function normalizeAmbitosIntervencion(
  value: Tenant['ambitos_intervencion'] | undefined
): any[] {
  if (!Array.isArray(value)) return [];
  return value.filter((x): x is any => typeof x === 'object' && x !== null);
}